export default __webpack_public_path__ + "static/media/map.d8edffd0.png";